import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home.vue"),
  },

  {
    path: "/announcement",
    name: "announcement",

    component: () => import("../views/announcement.vue"),
  },
  {
    path: "/criteria",
    name: "criteria",

    component: () => import("../views/criteria.vue"),
  },

  {
    path: "/glossary",
    name: "glossary",

    component: () => import("../views/glossary.vue"),
  },
  {
    path: "/formats",
    name: "formats",
    component: () => import("../views/formats.vue"),
  },
  {
    path: "/recursos",
    name: "recursos",
    component: () => import("../views/recursos.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
